import React from 'react'
import { AllowedAccess } from 'react-permission-role'
import { useLocation, useParams } from 'react-router-dom'
import { Card, CardContent, Grid, List, ListItem, ListItemButton, Button, IconButton } from '@mui/material';
import { Trash2 } from 'react-feather'

import { useFetchInitPermissions } from './hooks'
import { PermissionList } from './PermissionList'
import { ModalModule } from './ModalModule'

import { LinearLoading } from 'common'

export const Permissions = () => {
    
    const location = useLocation();
    const paramsURL = useParams();
    const useFetchInit = useFetchInitPermissions({location, paramsURL})

    const {
        //------------- Generales
        //------------- globalStates
        globalStates,
        //------------- Helpers
        // Helpers,
        //------------- Formularios
        // Forms,
        //------------- FetchData
        FetchData,
        //------------- Actions
        Actions
    } = useFetchInit

    // ------------------------------------------------ Generales
    // ------------------------------------------------ globalStates
    const { showForm } = globalStates
    // ------------------------------------------------ Helpers
    // ------------------------------------------------ Formularios
    // ------------------------------------------------ FetchData
    const { fetchAllPermissions } = FetchData
    const { loadingFetchPermissions, dataPermissions } = fetchAllPermissions
    // ------------------------------------------------ Actions
    const {
        handleClickDemoModal,
        handleClickDeleteData
    } = Actions

    return (
        <AllowedAccess permissions={['89_PERMISOS']} renderAuthFailed={<p>Error</p>}>
            <div className="content">
                <ModalModule useFetchInit={useFetchInit} />
                {(!showForm) && (
                    <>
                        <div className="panel-body">
                            <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                                <Grid item xs={12} sm={12} md={12} lg={12}>
                                    <Card style={{zIndex:'1'}}>
                                        <CardContent>
                                            
                                            <div className='h4 mt-1 mb-1'> Permisos </div>
                                            <div className="border-bottom border-dark"></div>
                                            {loadingFetchPermissions && ( <LinearLoading /> )}

                                            <div className="d-flex justify-content-end pt-4">
                                                <Button
                                                    style={{background: "#94521c"}}
                                                    variant="contained"
                                                    type="button"
                                                    onClick={()=>handleClickDemoModal('', 'CREAR PERMISO', 'FormPermission', { data: { idpermiso: '', idpermiso_padre: '', nombrepermisos: '', estado: '', nivel: '' } })}
                                                >
                                                    <i className="fa-solid fa-plus"></i> &nbsp; Agregar
                                                </Button>
                                            </div>

                                            <div className="pt-5"></div>

                                            {(dataPermissions.length === 0) && (
                                                <>
                                                    <p>NO SE ENCONTRARON PERMISOS</p>
                                                </>
                                            )}
                                            {(dataPermissions.length > 0) && (
                                                <>
                                                    <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
                                                        {dataPermissions.map((permiso) => (
                                                            <Grid item xs={12} sm={6} md={6} lg={6} key={permiso.idpermiso}>
                                                                <List>
                                                                    <ListItem 
                                                                        disablePadding
                                                                        secondaryAction={
                                                                            <IconButton edge="end" aria-label="delete" onClick={() => handleClickDeleteData(permiso.idpermiso)}>
                                                                                <Trash2 />
                                                                            </IconButton>
                                                                        }
                                                                    >
                                                                        <ListItemButton
                                                                            onClick={()=>handleClickDemoModal('', 'CREAR PERMISO ', 'FormPermission', { data: permiso })}
                                                                        >
                                                                            <h6>{permiso.nombrepermisos}</h6>
                                                                        </ListItemButton>
                                                                    </ListItem>
                                                                    {/* <Divider /> */}
                                                                    <div className="border-bottom border-secondary"></div>
                                                                    {permiso.hijos && permiso.hijos.length > 0 && (
                                                                        <PermissionList permissions={permiso.hijos} handleClickDemoModal={handleClickDemoModal} handleClickDeleteData={handleClickDeleteData} />
                                                                    )}
                                                                </List>
                                                            </Grid>
                                                        ))}
                                                    </Grid>
                                                    
                                                </>
                                            )}

                                            <div className="pt-4"></div>
                                            {/* <TableClient useFetchInit={useFetchInit} /> */}
                                        </CardContent>
                                    </Card>
                                </Grid>
                            </Grid>
                        </div>
                    </>
                )}
                {(showForm) && (
                    <>
                        <div className="panel-body">
                            {/* <FormClient useFetchInit={useFetchInit} /> */}
                        </div>
                    </>
                )}
            </div>
        </AllowedAccess>
    )

}
